/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * a custom list record status
 * @export
 * @enum {string}
 */
export enum InternalApiCustomListRecordStatus {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE'
}


export function instanceOfInternalApiCustomListRecordStatus(value: any): boolean {
    for (const key in InternalApiCustomListRecordStatus) {
        if (Object.prototype.hasOwnProperty.call(InternalApiCustomListRecordStatus, key)) {
            if (InternalApiCustomListRecordStatus[key as keyof typeof InternalApiCustomListRecordStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiCustomListRecordStatusFromJSON(json: any): InternalApiCustomListRecordStatus {
    return InternalApiCustomListRecordStatusFromJSONTyped(json, false);
}

export function InternalApiCustomListRecordStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListRecordStatus {
    return json as InternalApiCustomListRecordStatus;
}

export function InternalApiCustomListRecordStatusToJSON(value?: InternalApiCustomListRecordStatus | null): any {
    return value as any;
}

export function InternalApiCustomListRecordStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiCustomListRecordStatus {
    return value as InternalApiCustomListRecordStatus;
}

